<div class="footer" [class.footer__fixed]="isDesktop">
  <div class="container">
    <div class="footer__reviews">
      <div class="footer__reviews-item">
        <div
          id="widget-container"
          class="ekomi-widget-container ekomi-widget-sf1392905efde66aaff03"
        ></div>
        <a
          href="https://www.ekomi.es/testimonios-aparcandgo.html"
          target="_blank"
          ><img
            alt="Aparca&Go S.L Valoraciones con ekomi.es"
            src="https://ekomi-ui.s3.amazonaws.com/1.0.0/images/logo.png"
            class="hidden"
        /></a>
      </div>
      <div #google_container class="footer__reviews-item"></div>
    </div>
    <footer class="footer__bottom">
      <div class="footer__legal">
        <small>{{ 'sharedModule.bkgFooter.copyright' | translate }}</small>
        <nav class="footer__legal-nav">
          <a [href]="getPrivacyLink">{{
            'sharedModule.bkgFooter.privacy' | translate
          }}</a>
          <a [href]="getLegalLink">{{
            'sharedModule.bkgFooter.legal' | translate
          }}</a>
          <a [href]="getSiteMapLink">{{
            'sharedModule.bkgFooter.siteMap' | translate
          }}</a>
          <a>{{appVersion}}</a>
        </nav>
      </div>
    </footer>
  </div>
</div>
